import request from '@/utils/request'

// login
export function userLogin(data) {
	return request({
		url: '/updatesrv/v1/user/login',
		method: 'post',
		data
	})
}

// loging out
export function logingout() {
	return request({
		url: '/updatesrv/v1/user/logout',
		method: 'post'
	})
}

// device Info List get
export function deviceInfoList(startNum,readNum) {
	return request({
		url: '/updatesrv/v1/devicemgr/deviceinfolist?StartPos='+startNum+'&ReadNum='+readNum,
		method: 'get'
	})
}

// device Info List delete
export function deleteDeviceInfo(data) {
	return request({
		url: '/updatesrv/v1/devicemgr/deviceinfolist',
		method: 'delete',
		data
	})
}

// device Info List post
export function postDeviceInfo(data) {
	return request({
		url: '/updatesrv/v1/devicemgr/deviceinfolist',
		method: 'post',
		data
	})
}

// device excel get
export function getDeviceExcel(startNum,readNum) {
	return request({
		url: '/updatesrv/v1/devicemgr/excel/templatefile',
		method: 'get'
	})
}

// package List get
export function packageInfoList(startNum,readNum) {
	return request({
		url: '/updatesrv/v1/packagemgr/packageinfo/packageinfolist?StartPos='+startNum+'&ReadNum='+readNum,
		method: 'get'
	})
}

// package List delete
export function deletePackageInfo(data) {
	return request({
		url: '/updatesrv/v1/packagemgr/packageinfo/packageinfolist',
		method: 'delete',
		data
	})
}

// update log List get (params: StartPos, ReadNum, 以及可选过滤项 SN/IMEI/Product/FromVer/ToVer/StartTime/EndTime/Result)
export function updateLogList(params) {
	return request({
		url: '/updatesrv/v1/updatelog/updateloglist',
		method: 'get',
		params
	})
}

